import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import $ from 'jquery';

import 'jquery/dist/jquery.min.js';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'datatables.net-buttons/js/dataTables.buttons.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.flash.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-dt/css/jquery.dataTables.min.css';

const UnverifiedStudent = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios.get(`/unknown-students`).then((res) => {
      setData(res.data.data);

      // Initialize DataTables after setting the data
      setTimeout(() => {
        $('#example').DataTable({
          pagingType: 'full_numbers',
          pageLength: 15,
          processing: true,
          dom: 'Bfrtip',
          buttons: ['copyHtml5', 'excelHtml5', 'csvHtml5', 'print', 'pdf']
        });
      }, 1000);
    });
  }, []);

  return (
    <div style={{ width: '100%' }}>
      <div className="flex flex-col md:flex-row" style={{ width: '100%' }}>
        {data.length > 0 && (
          <section style={{ width: '100%' }}>
            <div
              id="main"
              className="main-content flex-1 bg-gray-100 mt-12 md:mt-2 pb-24 md:pb-5"
              style={{ width: '100%' }}
            >
              <div className="flex flex-wrap bg-white" style={{ width: '100%' }}>
                <div className="flex flex-col bg-white" style={{ width: '100%' }}>
                  <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                      <div className="overflow-x-auto">
                        <div className="MainDiv">
                          <div className="container p-5">
                            <table id="example" className="table table-hover table-bordered">
                              <thead>
                                <tr>
                                  <th>Sl.No</th>
                                  <th>Full Name</th>
                                  <th>Mobile No</th>
                                  <th>Email ID</th>
                                  <th>Program</th>
                                  <th>Gender</th>
                                  <th>Country</th>
                                  <th>Registration Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {data.map((result, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{result.name}</td>
                                    <td>{result.mobileNo}</td>
                                    <td>{result.email}</td>
                                    <td>{result.program}</td>
                                    <td>{result.gender}</td>
                                    <td>{result.country}</td>
                                    <td>{result.createdAt}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

export default UnverifiedStudent;
